import {
  useCreate,
  useDelete,
  useDetail,
  useList,
  useListInfinite,
  usePartialUpdate,
  usePlainList,
  useUpdate,
} from '@inmagik/react-crud'
import { QueryOnlyOptions } from '@inmagik/react-crud/dist/types'
import { API_URL } from '../constants'
import { AllegatoIntervento, Intervento } from '../types'
import { InterventoDettaglioClienteType } from '../typesCliente'

export function useInterventiList(params: Record<string, string> = {}) {
  return useList<Intervento>(`${API_URL}/bilance/intervento`, params)
}

export function useAvvisi(params: Record<string, string> = {}, queryOptions: QueryOnlyOptions = {}) {
  return usePlainList<Intervento>(`${API_URL}/bilance/intervento/avvisi`, params, queryOptions)
}

export function useIntervento(id: string) {
  return useDetail<Intervento>(`${API_URL}/bilance/intervento`, id)
}

export function useCreateIntervento() {
  return useCreate<Intervento>(`${API_URL}/bilance/intervento`)
}

export function useUpdateIntervento() {
  return useUpdate<Intervento>(`${API_URL}/bilance/intervento`)
}

export function useDeleteIntervento() {
  return useDelete(`${API_URL}/bilance/intervento`)
}

export function useInterventiCalendario(params: Record<string, string> = {}) {
  return usePlainList<Intervento>(`${API_URL}/bilance/intervento/calendario`, params, {
    enabled: true,
  })
}

// intervento dettaglio plain list per errori api campi-mancanti-per-esportazione
export function useInterventoDettaglioCampiMancanti(
  id: string,
  params: Record<string, string> = {},
  queryOptions: QueryOnlyOptions = {}
) {
  return usePlainList<string>(`${API_URL}/bilance/intervento/${id}/campi-mancanti-per-esportazione`, params, {
    enabled: true,
    ...queryOptions,
  })
}

export function useInterventiListInfinite(params: Record<string, string> = {}) {
  return useListInfinite<Intervento>(`${API_URL}/bilance/intervento`, params)
}

export function usePartialUpdateIntervento(encode: 'formdata' | 'json' = 'formdata') {
  return usePartialUpdate<Intervento>(`${API_URL}/bilance/intervento`, {
    encode,
  })
}

export function usePartialUpdateInterventoJson() {
  return usePartialUpdate<Intervento>(`${API_URL}/bilance/intervento`)
}

export function useAllegatiIntervento(params: Record<string, string> = {}, queryOptions: QueryOnlyOptions = {}) {
  return useList<AllegatoIntervento>(`${API_URL}/bilance/allegato-intervento`, params, queryOptions)
}

export function useCreateAllegatoIntervento() {
  return useCreate<AllegatoIntervento>(`${API_URL}/bilance/allegato-intervento`, {
    encode: 'formdata',
  })
}

export function useDeleteAllegatoIntervento() {
  return useDelete(`${API_URL}/bilance/allegato-intervento`)
}

export function useUpdateAllegatoIntervento() {
  return useUpdate<AllegatoIntervento>(`${API_URL}/bilance/allegato-intervento`, {
    encode: 'formdata',
  })
}

// #region CLIENTE
export function useInterventoCliente(id: string) {
  return useDetail<InterventoDettaglioClienteType>(`${API_URL}/bilance/intervento`, id)
}
